import axios from "axios";
import { url } from "../../axiosInstance";

export const getActiveOrders = (stationId, limit) => {
  const data = {
    ProcedureName: "GetOrderRealTimeDsp",
    Parameters: {
      _stationId: stationId,
      limi: limit,
      _collect: 0,
    },
  };

  return axios.post(
    `${url}ReportListView/getreportdatatablefromhamazon`,
    data,
    {
      headers: {
        Authorization: `bearer ${localStorage.token}`,
        "Access-Control-Allow-Origin": "*",
      },
    }
  );
};

export const updateStatus = (orderId, newStatus) => {
  const data = {
    orderId: orderId,
    status: newStatus,
  };
  return axios.post(`${url}Order/UpdateOrderStatus`, data, {
    headers: {
      Authorization: `bearer ${localStorage.token}`,
      "Access-Control-Allow-Origin": "*",
    },
  });
};

export const updateOrder = (orderId, orderById) => {
  const data = {
    orderId: orderId,
    orderById: orderById,
  };

  return axios.post(`${url}Order/SetOrderPriority`, data, {
    headers: {
      Authorization: `bearer ${localStorage.token}`,
      "Access-Control-Allow-Origin": "*",
    },
  });
};

// export const updateOrder = async (orderId, newStatus) => {
//   const res = await axios.get(`${url}ListView/GetAllTableProp`, {
//     headers: {
//       Authorization: `bearer ${localStorage.token}`,
//       "Access-Control-Allow-Origin": "*",
//     },
//   });
//   console.log(res);
// };
